let requestQueue = [];
let rowsBeforeDrag = [];
let backupData = [];

export function addRequestToQueue(request) {
    requestQueue.push(request);
}

export function addToRowsBeforeDrag(rows) {
    rowsBeforeDrag.push(rows);
}

export function processDragQueue(event, immutableRowData, isQueueProcessing) {
    if (!requestQueue?.length) {
        isQueueProcessing.current = false;
        return;
    }

    let request = requestQueue[0];
    if (!backupData.length && rowsBeforeDrag[0]) backupData = rowsBeforeDrag[0];

    request()
        .then(() => {
            requestQueue.shift();
            rowsBeforeDrag.shift();
            if (requestQueue.length) {
                processDragQueue(event);
            } else {
                isQueueProcessing.current = false;
            }
        })
        .catch(() => {
            if (!rowsBeforeDrag.length && backupData.length) {
                // backup for the exact moment when we set to [] the rowsBeforeDrag array
                // just after starting dragging a new row.
                // this prevents to break, because we can't slice() of undefined (rowsBeforeDrag[0])
                event.api.setGridOption('rowData', backupData);
                const backupRows = backupData.slice();
                immutableRowData.current = backupRows || [];
                isQueueProcessing.current = false;
            } else {
                event.api.setGridOption('rowData', rowsBeforeDrag[0]);
                const newRows = rowsBeforeDrag[0].slice();
                immutableRowData.current = newRows || [];
                backupData = rowsBeforeDrag[0] || [];
                requestQueue = [];
                rowsBeforeDrag = [];
                isQueueProcessing.current = false;
            }
        });
}
